import { render, staticRenderFns } from "./PeriodItemCard.vue?vue&type=template&id=0c6dd96e&scoped=true"
import script from "./PeriodItemCard.vue?vue&type=script&lang=js"
export * from "./PeriodItemCard.vue?vue&type=script&lang=js"
import style0 from "./PeriodItemCard.vue?vue&type=style&index=0&id=0c6dd96e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6dd96e",
  null
  
)

export default component.exports